import { ToastBuilder } from '@nu-art/thunderstorm-frontend/index';
import { _keys, filterInstances, isErrorOfType, Second, ValidationException } from '@nu-art/ts-common';
import { QToastContent } from './ui/index.js';
import { ModuleFE_Expression } from './_entity/expression/index.js';
import { ModuleFE_Variable } from './_entity/variable/index.js';
export const showToast = (iconKey, content, toastType) => {
    new ToastBuilder().setDuration(6 * Second)
        .setContent(QToastContent({ iconKey: iconKey, content: content, toastType: toastType }))
        .show();
};
export const handleError = (error, message, targetName) => {
    if (isErrorOfType(error, ValidationException)) {
        message = message ? message : `Invalid input for fields: ${filterInstances(_keys(error.result)).join(', ')}`;
        showToast('x', message, 'error');
    } /*else if (isErrorOfType(error, HasDependenciesException)) {
        showToast('x', QResolveDependencyToast({
            dependencyConflicts: error.body,
            deletedEntity: targetName!
        }), 'error');
    }*/
    else {
        showToast('x', 'Something went wrong.. Try again later', 'error');
    }
    throw error;
};
export function resolveRangeForPrint(input) {
    if (!input)
        return '';
    return input[0] === input[1] ? `${input[0]}` : `[${input}]`;
}
export const generateUserAcronym = (user, email) => {
    if (user?.firstName && user?.surname)
        return `${user.firstName.at(0).toUpperCase()}${user.surname.at(0).toUpperCase()}`;
    return email.substring(0, 2).toUpperCase();
};
export const hasDuplicateNameExpression = (expression) => {
    return !!ModuleFE_Expression.cache.find(expr => {
        if (expr._id === expression._id)
            return false;
        return expr.label.toLowerCase().trim() === expression.label?.toLowerCase().trim();
    });
};
export const findDuplicateVariableByName = (variable) => {
    const name = variable.name?.toLowerCase().trim();
    if (!name)
        return undefined;
    return ModuleFE_Variable.cache.find(v => {
        if (v._id === variable._id)
            return false;
        return v.name.toLowerCase().trim() === name;
    });
};
export const hasDuplicateVariableName = (variable) => !!findDuplicateVariableByName(variable);
//# sourceMappingURL=utils.js.map